import { render, staticRenderFns } from "./vendorView.vue?vue&type=template&id=66e69953&scoped=true"
import script from "./vendorView.vue?vue&type=script&lang=js"
export * from "./vendorView.vue?vue&type=script&lang=js"
import style0 from "./vendorView.vue?vue&type=style&index=0&id=66e69953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e69953",
  null
  
)

export default component.exports